import React from "react";

import { pdf } from "@react-pdf/renderer";
import { groupBy } from "lodash";

import client from "@/client";
import { MealKind, MealRatingByDateRange } from "@/gql/graphql";
import { formatISODate } from "@/utils/datetime";

import { addMissingRating, mealRatingReportQuery } from "./useMealRatingReport";
import MealRatingReportPDF from "../components/MealRatingReportPDF/MealRatingReportPDF";

export const downloadReportPDF = async (
  clientId: string,
  startDate: Date,
  endDate: Date
): Promise<void> => {
  const formattedStartDate = formatISODate(startDate);
  const formattedEndDate = formatISODate(endDate);

  const { data } = await client.query({
    query: mealRatingReportQuery,
    variables: {
      clientId,
      startDate: formattedStartDate,
      endDate: formattedEndDate,
    },
  });

  if (data?.mealRatingByDateRange.length == 0) return;

  // Group data according to mealType
  const groupedMealRatingReport = groupBy(
    data?.mealRatingByDateRange,
    "mealType"
  );

  // Modified the grouped data and assign zero value for ratings that have no totalRating
  const mealRatingReport = Object.entries(groupedMealRatingReport).map(
    ([type, ratings]) =>
      ({
        [type]: addMissingRating(ratings),
      } as Record<MealKind, MealRatingByDateRange[]>)
  );

  const fileName = `meal-rating-report_${formattedStartDate}-to-${formattedEndDate}.pdf`;
  const blob = await pdf(
    <MealRatingReportPDF
      data={mealRatingReport}
      startDate={startDate}
      endDate={endDate}
    />
  ).toBlob();
  const link = document.createElement("a");
  link.download = fileName;
  link.href = URL.createObjectURL(blob);
  link.click();
};
